import React, { useEffect, useState } from 'react'
import * as playerAPI from './services/player'
import * as matchAPI from './services/matches'
import * as importAPI from './services/import'
import PlayersDisplay from './components/PlayersDisplay'
import MatchesDisplay from './components/MatchesDisplay'

const App = () => {
  const [players, setPlayers] = useState([])
  const [matches, setMatches] = useState([])

  useEffect(() => {
    const init = async () => {
      const existingPlayers = playerAPI.getAll()
      const existingMatches = matchAPI.getAll()

      // If storage is empty (first visit), import the sample dataset automatically.
      if ((!existingPlayers || existingPlayers.length === 0) && (!existingMatches || existingMatches.length === 0)) {
        try {
          const res = await importAPI.importFromSampleFile()
          if (res && res.success) {
            // After successful import, reload from storage so UI shows the sample data.
            setPlayers(playerAPI.getAll())
            setMatches(matchAPI.getAll())
            return
          }
        } catch (err) {
          console.error('Failed to import sample data', err)
        }
      }

      // Fallback: use whatever is present in storage.
      setPlayers(existingPlayers)
      setMatches(existingMatches)
    }

    init()
  }, [])

  return (
    <div className="main-container">
      <div className="title-container">
        <h1>Liga chuliganów</h1>
        <p className="subtitle">Na podstawie wyników spotkań bezpośrednich, z pominięciem wyników koalicji. Punktacja Elo.</p>
        <div className="header-notes">
          <p>Wrzucone są spotkania z lat 2014–2024; niektóre mogły zostać pominięte, a część wyników może być nieścisła.</p>
          <p>Ranking może być niemiarodajny ze względu na różną aktywność drużyn (lub jej brak). Mała ekipa, która spotyka głównie słabszych rywali i dużo wygrywa, może sztucznie podbijać swoje punkty.</p>
          <p>Można rozważyć współczynniki uwzględniające aktywność lub liczbę meczów. To wersja robocza — chętnie zbierzemy uwagi.</p>
          <p>Aktualizacja: za każdy rok odejmowane jest 5%, co powinno zmniejszyć wagę dawnych starć.</p>
        </div>
      </div>
      <PlayersDisplay players={players} setPlayers={setPlayers} />
      <hr></hr>
      <MatchesDisplay matches={matches} players={players} setPlayers={setPlayers} setMatches={setMatches}/>
    </div>
  )
}

export default App
